const mediaItems = [
  {
    title: '顶流男星深夜密会完整追踪',
    duration: '08:32',
    views: '128.6万',
    tag: '热门',
    img: 'https://readdy.ai/api/search-image?query=night%20scene%20of%20luxury%20hotel%20with%20dramatic%20lighting%2C%20paparazzi%20style%20photography%2C%20dark%20atmosphere%20with%20warm%20street%20lights%2C%20mysterious%20urban%20night%20vibe%2C%20editorial%20news%20style&width=800&height=450&seq=media-51hlw-01&orientation=landscape',
  },
  {
    title: '网红直播翻车现场原声回放',
    duration: '05:17',
    views: '96.3万',
    tag: '爆款',
    img: 'https://readdy.ai/api/search-image?query=live%20streaming%20studio%20with%20dramatic%20ring%20light%2C%20professional%20streaming%20setup%2C%20dark%20room%20with%20warm%20lighting%2C%20social%20media%20influencer%20aesthetic%2C%20cinematic%20mood&width=800&height=450&seq=media-51hlw-02&orientation=landscape',
  },
  {
    title: '综艺节目争执画面独家还原',
    duration: '12:04',
    views: '75.8万',
    tag: '独家',
    img: 'https://readdy.ai/api/search-image?query=television%20studio%20set%20with%20dramatic%20stage%20lighting%2C%20empty%20chairs%20and%20equipment%2C%20professional%20broadcast%20environment%2C%20dark%20background%20with%20warm%20spotlights&width=800&height=450&seq=media-51hlw-03&orientation=landscape',
  },
  {
    title: '女团成员聊天记录逐条解析',
    duration: '15:41',
    views: '62.4万',
    tag: '深扒',
    img: 'https://readdy.ai/api/search-image?query=smartphone%20displaying%20messages%20on%20dark%20desk%2C%20dramatic%20lighting%20from%20screen%2C%20night%20atmosphere%2C%20mysterious%20mood%2C%20warm%20glow%20against%20darkness%2C%20editorial%20style&width=800&height=450&seq=media-51hlw-04&orientation=landscape',
  },
  {
    title: '新片选角内幕线人独家访谈',
    duration: '22:18',
    views: '48.9万',
    tag: '重磅',
    img: 'https://readdy.ai/api/search-image?query=interview%20setting%20with%20silhouetted%20figure%20against%20bright%20light%2C%20anonymous%20source%20atmosphere%2C%20dramatic%20backlighting%2C%20dark%20surroundings%2C%20investigative%20journalism%20vibe&width=800&height=450&seq=media-51hlw-05&orientation=landscape',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-semibold mb-3">独家视频</span>
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950">独家视频</h2>
          <p className="text-foreground-600 text-sm mt-2">第一手猛料视频，全网独家放送</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {mediaItems.slice(0, 3).map((item, i) => (
            <div key={i} className="group bg-background-50 rounded-xl border border-background-200/70 overflow-hidden cursor-pointer transition-all hover:border-primary-200">
              <div className="relative aspect-video overflow-hidden bg-background-200">
                <img
                  src={item.img}
                  alt={`51黑料网视频 - ${item.title}`}
                  title={`51黑料网独家视频 - ${item.title}`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  onError={(e) => {
                    (e.target as HTMLElement).parentElement!.style.display = 'none';
                  }}
                />
                <div className="absolute inset-0 bg-black/20 group-hover:bg-black/30 transition-colors flex items-center justify-center">
                  <div className="w-12 h-12 rounded-full bg-primary-500/90 flex items-center justify-center group-hover:scale-110 transition-transform">
                    <i className="ri-play-fill text-background-50 text-xl ml-0.5"></i>
                  </div>
                </div>
                <div className="absolute bottom-3 right-3 px-2 py-1 rounded bg-black/70 text-background-50 text-xs font-medium">
                  {item.duration}
                </div>
                <div className="absolute top-3 left-3">
                  <span className="px-2 py-0.5 rounded bg-primary-500 text-background-50 text-xs font-semibold">
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-bold text-foreground-900 leading-snug group-hover:text-primary-600 transition-colors line-clamp-2">{item.title}</h3>
                <p className="text-xs text-foreground-500 mt-2 flex items-center gap-1">
                  <i className="ri-eye-line"></i>{item.views} 次观看
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 mt-5">
          {mediaItems.slice(3).map((item, i) => (
            <div key={i} className="group bg-background-50 rounded-xl border border-background-200/70 overflow-hidden cursor-pointer transition-all hover:border-primary-200 flex flex-col sm:flex-row">
              <div className="relative sm:w-64 flex-shrink-0 aspect-video sm:aspect-auto overflow-hidden bg-background-200">
                <img
                  src={item.img}
                  alt={`51黑料网视频 - ${item.title}`}
                  title={`51黑料网独家视频 - ${item.title}`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  onError={(e) => {
                    (e.target as HTMLElement).parentElement!.style.display = 'none';
                  }}
                />
                <div className="absolute inset-0 bg-black/20 group-hover:bg-black/30 transition-colors flex items-center justify-center">
                  <div className="w-10 h-10 rounded-full bg-primary-500/90 flex items-center justify-center group-hover:scale-110 transition-transform">
                    <i className="ri-play-fill text-background-50 text-lg ml-0.5"></i>
                  </div>
                </div>
                <div className="absolute bottom-2 right-2 px-1.5 py-0.5 rounded bg-black/70 text-background-50 text-xs font-medium">
                  {item.duration}
                </div>
                <div className="absolute top-2 left-2">
                  <span className="px-1.5 py-0.5 rounded bg-primary-500 text-background-50 text-xs font-semibold">
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="p-4 flex-1 flex flex-col justify-center">
                <h3 className="text-sm font-bold text-foreground-900 leading-snug group-hover:text-primary-600 transition-colors">{item.title}</h3>
                <p className="text-xs text-foreground-500 mt-2 flex items-center gap-1">
                  <i className="ri-eye-line"></i>{item.views} 次观看
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}